var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewport scanner mx-auto",style:({width: _vm.readerSize.width +'px', height: _vm.readerSize.height +'px'}),attrs:{"id":"interactive"}},[_c('video'),_c('canvas',{staticClass:"drawingBuffer"})])}
var staticRenderFns = []

export { render, staticRenderFns }